import { render, staticRenderFns } from "./TelegramDetails.vue?vue&type=template&id=21e0e757&"
import script from "./TelegramDetails.vue?vue&type=script&lang=js&"
export * from "./TelegramDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports